import { actionTypes } from "../actions/types";

const EditReducer = (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_EVENT:
      return { ...state, editEvent: action.payload };
    case actionTypes.CLEAR_EVENT:
      return { ...state, editEvent: undefined };
    default:
      return state;
  }
};

export default EditReducer;
